
import CalCompleteBouquet from "~/components/cart-dialog/cal-complete-bouquet.vue";
import CalRecipientDetails from "~/components/cart-dialog/cal-recipient-details.vue";
import CalDeliveryWindow from "~/components/cart-dialog/cal-delivery-window.vue";
import CalCardMessage from "~/components/cart-dialog/cal-card-message.vue";
import CalSameAddressDelivery from "~/components/cart-dialog/cal-same-address-delivery.vue";
import CalBasketBanner from "~/components/cart-dialog/cal-basket-banner.vue";
import CalHeaderWithProgress from "~/components/cal-header-with-progress.vue";
import CalVasesAddons from "~/components/cal-vases-addons.vue";
import DiscountMixin from "~/mixin/discount-mixin";
import CalGreetSection from "../cart-dialog/cal-greet-section.vue";
import CalAddToBasketFlow from "../cart-dialog/cal-add-to-basket-flow.vue";
import HelperMixin from "~/mixin/helper-mixin";
import UpgradeBouquet from '../cart-dialog/upgrade-bouquet.vue';

/**
 * Note:: Implementing  @closeCartDialog and :showCartDialog is is must in every cart workflow.
 */
export default {
  name: "cal-floral-checkout",
  components: {
    CalCompleteBouquet,
    CalRecipientDetails,
    CalDeliveryWindow,
    CalCardMessage,
    CalSameAddressDelivery,
    CalBasketBanner,
    CalHeaderWithProgress,
    CalVasesAddons,
    CalGreetSection,
    CalAddToBasketFlow,
    UpgradeBouquet
  },
  mixins: [DiscountMixin, HelperMixin],
  props: {
    showCartDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    isLoadAddons: {
      type: Boolean,
      required: true,
    },
    isCentrepiece: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDried: {
      type: Boolean,
      required: false,
      default: false,
    },
    isNoVase: {
      type: Boolean,
      required: false,
      default: false,
    },
    isReLoadRecipientDialog: {
      type: Boolean,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    scrollToError(){
      this.scrollToFirstError(this.validationStatus);
    },
    closeCartDialog() {
      this.$emit("closeCartDialog");
      this.resetSameAddressDeliveryStates();
    },
    checkIfValidOrder() {
      if (
        !this.validationStatus.recipientDetailsDisabled &&
        !this.validationStatus.deliveryWindowDisabled &&
        !this.validationStatus.cardMessageDisabled &&
        ((this.config.isSameOrderEligble &&
          !this.validationStatus.sameOrderDisabled) ||
          !this.config.isSameOrderEligble)
      ) {
        this.$nuxt.$emit("disableContinue", false);
      } else {
        this.$nuxt.$emit("disableContinue", true);
      }
    },
  },
  watch: {
    showCartDialog() {
      this.config.isSameOrderEligble = this.isEligbleForDeliveryDiscount();
    },
    "validationStatus.recipientDetailsDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.deliveryWindowDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.cardMessageDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.sameOrderDisabled"() {
      this.checkIfValidOrder();
    },
  },
  data() {
    return {
      workflow: "FLORAL",
      isEditFlow: false,
      config: {
        displayAddons: true,
        displayGreets: true,
        displayVases: this.isNoVase ? false : true,
        displayDonation: true,
        autoSelectGreets: false,
        isSameOrderEligble: false,
      },
      validationStatus: {
        recipientDetailsDisabled: true,
        deliveryWindowDisabled: true,
        cardMessageDisabled: true,
        sameOrderDisabled: true,
      },
    };
  },
  created() {
    this.$nuxt.$on("recipientDetailsDisabled", (isDisabled) => {
      this.validationStatus.recipientDetailsDisabled = isDisabled;
    });
    this.$nuxt.$on("deliveryWindowDisabled", (isDisabled) => {
      this.validationStatus.deliveryWindowDisabled = isDisabled;
    });
    this.$nuxt.$on("cardMessageDisabled", (isDisabled) => {
      this.validationStatus.cardMessageDisabled = isDisabled;
    });
    this.$nuxt.$on("sameOrderDisabled", (isDisabled) => {
      this.validationStatus.sameOrderDisabled = isDisabled;
    });

    this.config.isSameOrderEligble =
      this.$store.state.cartItem.sameDayDelivery.isSameAddressOrder;
    this.isEditFlow =
      sessionStorage.getItem("editCartItemId") &&
      sessionStorage.getItem("editCartItemId").length > 0
        ? true
        : false;
  },
  mounted() {
      this.config.isSameOrderEligble = this.isEligbleForDeliveryDiscount();
  },
};
